var $a4b49a4502f68578$exports = {};
$a4b49a4502f68578$exports = {
    "clear": `T\xf8m`,
    "invalid": `(ugyldig)`,
    "loading": `Laster inn ...`,
    "noResults": `Ingen resultater`,
    "valid": `(gyldig)`
};


export {$a4b49a4502f68578$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
